import { render, staticRenderFns } from "./pyramid-valley-vineyards.vue?vue&type=template&id=1312e1a6&scoped=true"
import script from "./pyramid-valley-vineyards.vue?vue&type=script&lang=js"
export * from "./pyramid-valley-vineyards.vue?vue&type=script&lang=js"
import style0 from "./pyramid-valley-vineyards.vue?vue&type=style&index=0&id=1312e1a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1312e1a6",
  null
  
)

export default component.exports